import { SET_SNACK_STATE } from './actionTypes';

export const setSnackState = (snackState) => {
  return {
    type: SET_SNACK_STATE,
    snackState,
  };
};
